module.exports = __webpack_public_path__ + "img/TFM-N.53dab73c.gif";